// Footer.js
import React from "react";
import { Box, Typography, Container, Link } from "@mui/material";

const Footer = () => {
  return (
    <Box sx={{ bgcolor: "#6a11cb", color: "white", padding: "16px 0" }}>
      <Container maxWidth="lg">
        <Typography variant="body1" align="center">
          &copy; {new Date().getFullYear()} Gracious Sacco. All rights reserved.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 3, marginTop: 2 }}>
          <Link href="#" color="inherit" sx={{ textDecoration: "none" }}>
            Privacy Policy
          </Link>
          <Link href="#" color="inherit" sx={{ textDecoration: "none" }}>
            Terms of Service
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
